import { render, staticRenderFns } from "./aliPay.vue?vue&type=template&id=55d19f0c&scoped=true"
import script from "./aliPay.vue?vue&type=script&lang=js"
export * from "./aliPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d19f0c",
  null
  
)

export default component.exports